import React from 'react'
import { Avatar } from 'packages/eid-ui'
import { MIDPathToImage } from 'packages/core/helpers'
import appConfig from 'config'
import { styled } from '@mui/material'

const StyledAvatar = styled(Avatar)({
    marginLeft: '0.4rem',
})

const CellAvatar = ({ attribute, data }) => {
    const avatarProps = {
        size: 'large',
        src:
            data[attribute.src] &&
            MIDPathToImage(appConfig.BASE_EID_URL, data[attribute.src]),
        alt:
            data.firstName || data.lastName
                ? `${data.firstName || ''} ${data.lastName || ''}`.trim()
                : data.friendlyName || data.name || '',
    }

    return (
        <>
            <StyledAvatar {...avatarProps} />
        </>
    )
}

export default CellAvatar
